import axios from "axios";
// Create Function to handle requests from the backend
export const API = async (URL, METHOD, DATA) => {
    const options = {
        url: `${URL}`,
        method: METHOD,
        headers: {
            // Accept: "application/json",
            // "Content-Type": "application/json;charset=UTF-8",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
        },
        data : DATA
    };
    const response = await axios(options);
    return response;

}
